import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { api } from '../lib/api';
import { deriveScreenConnectionCounts } from '../lib/dashboard/screenStatus';
import { useOrganisationId } from '../lib/session';

/**
 * Header bell → Activity. The dot only shows while screens are offline or not
 * reporting, so it always means something.
 */
export function NotificationsBell() {
  const { t } = useTranslation('layout');
  const organisationId = useOrganisationId();
  const screensQuery = useQuery({
    queryKey: ['screens', organisationId],
    queryFn: () => api.listScreens(organisationId),
    refetchInterval: 60_000,
  });

  const counts = deriveScreenConnectionCounts(screensQuery.data ?? []);
  const needsAttention = counts.offline + counts.unknown;
  const label = needsAttention
    ? t('header.notificationsAttention', { count: needsAttention })
    : t('header.notifications');

  return (
    <Link
      to="/activity"
      title={label}
      aria-label={label}
      className="relative grid h-[42px] w-[42px] place-items-center rounded-xl no-underline transition-colors hover:bg-[var(--gs-panel2)]"
      style={{ color: 'var(--gs-ink2)' }}
    >
      <svg
        width="21"
        height="21"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.9"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden
      >
        <path d="M6 8a6 6 0 1 1 12 0c0 7 3 9 3 9H3s3-2 3-9" />
        <path d="M10.3 21a1.94 1.94 0 0 0 3.4 0" />
      </svg>
      {needsAttention ? (
        <span
          className="absolute end-2.5 top-2 h-2 w-2 rounded-full border-2"
          style={{ background: 'var(--gs-accent)', borderColor: 'var(--gs-panel)' }}
          aria-hidden
        />
      ) : null}
    </Link>
  );
}
